import Vue from 'vue'
// @ts-ignore - without it, there is a type warning and no @types package found for this
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.component('qr-code', VueQRCodeComponent);
